import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject, bindable } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { ValidationController, ValidationRules, Validator } from "aurelia-validation";
import { Models } from "models/core";
import { ErrorService } from "services/error-service";
import { LocationCodeService } from "services/location-code-service";
import { ServiceConsumptionSewingThreadService } from "services/service-consumption-sewing-thread-service";
import { ServiceProductService } from "services/service-product-service";
import { ToastService } from "services/toast-service";

@autoinject
export class SewingThreadInlineNew {
  @bindable private service: Models.Service;
  @bindable private newFormVisible;

  private sewingThread: Models.ServiceConsumptionSewingThread = new Models.ServiceConsumptionSewingThread();

  private sewingThreadTypeServices: Models.SewingThreadTypeService[] = [];
  private validationController: ValidationController;

  constructor(
    private errorService: ErrorService,
    private serviceConsumptionSewingThreadService: ServiceConsumptionSewingThreadService,
    private eventAggregator: EventAggregator,
    private toastService: ToastService,
    private t: I18N,
    private validator: Validator, 
    validationController: ValidationController,
    private serviceProductservice: ServiceProductService,
    private locationCodeService: LocationCodeService 
  ) {
    this.validationController = validationController;
  }

  protected applyValidationRules(item: Models.ServiceConsumptionSewingThread) {
      ValidationRules.ensure('SewingThreadTypeServiceId')
        .required()
        .withMessage(this.t.tr('general.requiredField'))
        .ensure('Consumption')
        .required()
        .withMessage(this.t.tr('general.requiredField'))
        .min(0)
        .withMessage(this.t.tr('validation.mustBeGreaterOrEqualToValue', { value: 0 }))
        .ensure('ProductionNumber')
        .required()
        .withMessage(this.t.tr('general.requiredField'))
        .on(item);
  }

  private async validate(item: Models.ServiceConsumptionSewingThread) {
    this.applyValidationRules(item);
    await this.validator.validateObject(item);
    return (await this.validationController.validate({ object: item })).valid;
  }

  protected attached() {
    this.applyDefaultLocationCode();
    void this.getSewingThreadTypeServices();
  }

  private applyDefaultLocationCode() {
    const defaultLocationCodeId = this.service?.ServiceStation?.DefaultLocationCodeId;
    if (defaultLocationCodeId && !this.sewingThread.LocationCodeId) {
      this.sewingThread.LocationCodeId = defaultLocationCodeId;
    }
  }

  private async getSewingThreadTypeServices() {
    const result = await this.serviceProductservice.getSewingThreadTypesService('Repair', this.service.Id);
    this.sewingThreadTypeServices = result.data;
  }

  protected async createSewingThread() {
    try {
      //removed expanded objects
      delete this.sewingThread.SewingThreadTypeService;
      delete this.sewingThread.LocationCode;

      if (!(await this.validate(this.sewingThread))) return;
      this.sewingThread.LocationCodeId = this.sewingThread.LocationCodeId || null;

      // add serviceId
      this.sewingThread.ServiceId = this.service.Id;
      
      await this.serviceConsumptionSewingThreadService.post(this.sewingThread);
      this.sewingThread = null;
      this.eventAggregator.publish('serviceConsumptionSewingThreadsListReset', 0);
      this.toastService.showSuccess('service.consumptionThreadCreated');
      this.newFormVisible = false;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

    protected cancel() {
    this.newFormVisible = null;
    this.eventAggregator.publish('serviceConsumptionSewingThreadsListReset', 0);
  }
}